import { H4, LI, P, UL } from "../../../../AbstractElements";
import { CommentsLearning, DateLearning, DetailedCourseHeading, DetailedCourseParagraph1, DetailedCourseParagraph2 } from "../../../../Constant";

const BlogDetails = () => {
  return (
    <div className="blog-details">
      <UL className=" blog-social d-block simple-list">
        <LI className="rounded-0">{DateLearning}</LI>
        <LI><i className="icofont icofont-user" />Mark <span>Jecno </span></LI>
        <LI><i className="icofont icofont-thumbs-up" />02 <span>Hits </span></LI>
        <LI><i className="icofont icofont-ui-chat" />{CommentsLearning}</LI>
      </UL>
      <H4>{DetailedCourseHeading}</H4>
      <div className="single-blog-content-top">
        <P>{DetailedCourseParagraph1}</P>
        <P>{DetailedCourseParagraph2}</P>
      </div>
    </div>
  );
};

export default BlogDetails;
